// removed by extract-text-webpack-plugin
module.exports = {"root":"root_1hbSO","rect_1":"rect_1_1meLo","rect_2":"rect_2_2Ai1E","rect_3":"rect_3_39uPb","rect_4":"rect_4_3t89I","rect_5":"rect_5_2tYxx","sk-waveStretchDelay":"sk-waveStretchDelay_ulc3o","orange":"orange_1tVD2","white":"white_3xOuA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/style.css
// module id = 187
// module chunks = 0